import { X } from "lucide-react";
import { QuoteSummary } from "./QuoteSummary";
import { useT } from "./i18n";

export function ConfirmDialog({ kind, onClose, onConfirm, busy, summary }) {
  const isAccept = kind === "accept";
  const { t } = useT();
  return (
    <div className="fixed inset-0 z-50 bg-black/45 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl border border-[#E5E5E0] max-h-[92vh] overflow-y-auto"
        style={{ boxShadow: "0 20px 50px rgba(15,18,16,.22)" }} onClick={(e) => e.stopPropagation()} data-testid={`confirm-${kind}-dialog`}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E5E5E0]">
          <div className="font-display font-bold text-base">{isAccept ? t("confirm_title") : t("reject_title")}</div>
          <button type="button" onClick={onClose} className="p-2 rounded-lg hover:bg-[#F0F0EB]" aria-label={t("close")}><X size={16} /></button>
        </div>
        <div className="p-5 space-y-4">
          {isAccept ? (
            <>
              <p className="text-sm text-[#525252]">{t("confirm_intro")}</p>
              <div className="rounded-xl bg-[#FAFAF6] border border-[#E5E5E0] p-4">
                <QuoteSummary {...summary} testidPrefix="confirm" />
              </div>
            </>
          ) : (
            <>
              <p className="text-sm font-semibold text-[#111110]">{t("reject_question")}</p>
              <p className="text-xs text-[#525252]">{t("reject_intro")}</p>
            </>
          )}
          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} disabled={busy} className="ds-btn min-h-[44px] justify-center" data-testid={`confirm-${kind}-cancel`}>{t("cancel")}</button>
            <button type="button" onClick={onConfirm} disabled={busy}
              className={`ds-btn ${isAccept ? "primary" : "danger"} min-h-[44px] justify-center font-semibold`} data-testid={`confirm-${kind}-submit`}>
              {busy ? t("processing") : isAccept ? t("confirm_submit") : t("reject_submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
